import { useStaticQuery, graphql } from "gatsby";
import PropTypes from "prop-types";
import React from "react";
import { Helmet } from "react-helmet";

function SEO({ description, meta, keywords, title, ssOverride=null }) {
  const { site, storyblokEntry } = useStaticQuery(graphql`
    query DefaultSEOQuery {
      site {
        siteMetadata {
          title
          description
          author
          siteUrl
        }
      }
      storyblokEntry(slug: { eq: "header" }) {
        content
      }
    }
  `);

  const metaDescription = description || site.siteMetadata.description;

  const storyData = JSON.parse(storyblokEntry.content);

  const ssFix = ssOverride?.replace("https://a.storyblok.com/","https://d2bv7sklk9z912.cloudfront.net/1600x900/smart/filters:quality(95)/")

  const socialSharing = ssFix || storyData.social_sharing?.filename || `/images/wb-social-sharing.jpg`

  return (
    <Helmet
      htmlAttributes={{
        lang: `en`,
      }}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: `${title} | ${site.siteMetadata.title}`,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `meta-title`,
          content: `${title} | ${site.siteMetadata.title}`,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: socialSharing,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: `${title} | ${site.siteMetadata.title}`,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `name`,
          content: `${title} | ${site.siteMetadata.title}`,
        },
      ]
        .concat(
          keywords.length > 0
            ? {
                name: `keywords`,
                content: keywords.join(`, `),
              }
            : []
        )
        .concat(meta)}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
    ></Helmet>
  );
}

SEO.defaultProps = {
  keywords: [],
  meta: [],
};

SEO.propTypes = {
  description: PropTypes.string,
  keywords: PropTypes.arrayOf(PropTypes.string),
  meta: PropTypes.array,
  title: PropTypes.string.isRequired,
};

export default SEO;
